import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { getProductDetails } from '../../app/store/actions/products';
import inputSize from '../../data/inputs';

class ProductLeadTimeModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      userInput: '',
      messageErro: '',
      leadTime: '',
    };
  }

  closeProductLeadTimeModal = async () => {
    await this.props.openOrCloseModal();
    await this.setState({
      userInput: '',
      messageErro: '',
      leadTime: '',
    });
  }

  handleUserInput = async (userInput) => {
    const regexOnlyNumbers = /^(|0|[1-9]\d*)(.|,)?(\d+)?$/;
    if (regexOnlyNumbers.test(userInput) && !isNaN(userInput)) await this.setState({ userInput });
  }

  handleEnterKeyPress = async (event, productCode, productClientCode) => {
    if (event) event.preventDefault();
    await this.getProductLeadTime(productCode, productClientCode);
  }

  getProductLeadTime = async (productCode, productClientCode) => {
    const { leadTime, userInput } = this.state;
    const { productStock } = this.props;

    await this.setState({ messageErro: '' });

    if (!userInput) {
      await this.setState({ messageErro: I18n.t('requiredQuantity') });
    } else if (parseFloat(userInput) > productStock) {
      if (!leadTime) {
        try {
          const productData = await this.props.getProduct(productCode, productClientCode, true);

          if (productData && productData.price && productData.price.leadTimePrice) {
            await this.setState({ leadTime: productData.price.leadTimePrice });
          } else {
            await this.setState({ messageErro: I18n.t('leadTimeNotFound') });
          }
        } catch (error) {
          await this.setState({ messageErro: I18n.t('errorTryLater') });
        }
      }
    } else {
      await this.setState({ messageErro: I18n.t('reportedQuantityGreaterTotalStock') });
    }
  }

  render() {
    const { showModal = false, productCode, productClientCode } = this.props;
    const { userInput, messageErro, leadTime } = this.state;

    return (
      <div
        className="modal"
        role="presentation"
        id="product-feedback"
        style={{ display: showModal ? 'block' : 'none', zIndex: '10' }}
      >
        <div className="modal-content modal-content-product-feedback">
          <div className="modal-body">
            <div className="product-feedback-modal-close">
              <FontAwesomeIcon icon={faTimes} onClick={this.closeProductLeadTimeModal} />
            </div>
            <div className="column body-modal-text" style={{ padding: '10px 0 10px 0' }}>
              <div className="_reason-cancel-order">
                <div className="product-feedback-row ">
                  <p className="product-feedback-label">{I18n.t('quantityWishBuy')}</p>
                  <div className="product-leadtime-form">
                    <input
                      required
                      type="text"
                      className="product-feedback-select product-leadtime-input"
                      maxLength={inputSize.maxDefault}
                      placeholder={I18n.t('sampleNumber')}
                      value={userInput}
                      onChange={event => this.handleUserInput(event.target.value)}
                      onKeyDown={event => event.key === 'Enter'
                          && this.handleEnterKeyPress(event, productCode, productClientCode)}
                    />
                    <button
                      type="button"
                      className="button-product-feedback"
                      style={{ minWidth: '100px' }}
                      onClick={() => this.getProductLeadTime(productCode, productClientCode)}
                    >
                      {I18n.t('okButton')}
                    </button>
                  </div>
                </div>
                {leadTime && (
                  <div className="product-feedback-row" style={{ paddingBottom: '10px' }}>
                    <span className="product-seals time">
                      {I18n.t('quantityAvailable')}
                      {' '}
                      {leadTime}
                      {' '}
                      {I18n.t('days')}
                    </span>
                  </div>
                )}
              </div>
              {!!messageErro && (
                <p className="product-feedback-label" style={{ marginTop: '10px', color: 'red' }}>{messageErro}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  listProductFeedbackReason: state.settings.listProductFeedbackReason,
});

const mapDispatchToProps = dispatch => ({
  getProduct: (productId, code, forceProductLeadTime) => dispatch(
    getProductDetails(productId, code, forceProductLeadTime),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductLeadTimeModal);
